module.exports = __webpack_public_path__ + "static/img/f-i-two.abe7f86.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home-four/f-i-two.png
// module id = ytNi
// module chunks = 0